import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  columns: [
    {
      label: 'Name', field: 'name'
    },
    {
      label: 'Long Shift', field: 'long_shift'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/job/categorys/status/AC'}
    useIPA.get(param).then(response => {
      const jobcategory = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...jobcategory})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/job/category/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        long_shift: parseInt(formData.text_1),
        name: formData.text_2
			}
      const param = { rawData: rawData, url: 'dashboard/master/job/category', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'profession-job-category' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/job/category', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, jobcategory) {
    state.all = jobcategory.rows
    state.pages = jobcategory.pages
  },
  setJobCatData (state, jobcat) {
    state.JobCat = jobcat.rows
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
